import { useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { isSmallMobileDeviceQuery } from 'src/util/responsive';

interface Props {
  children: JSX.Element[] | JSX.Element;
  paddingTop?: boolean;
}

export const TwoColumnGridContainer: FC<Props> = ({ children, paddingTop = true }) => {
  const isSmallMobileDevice = useMediaQuery(isSmallMobileDeviceQuery);
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: isSmallMobileDevice ? '1fr' : '1fr 1fr',
        gap: '24px',
        paddingTop: paddingTop ? 'unset' : 'unset',
        alignItems: 'stretch',
      }}
    >
      {children}
    </div>
  );
};
